(() => {
  const STOREFRONT_TOKEN = 'a4980205ab0c74ea6c2757abf2bd780f';
  const SHOP_DOMAIN = 'w2augj-20.myshopify.com';
  const API_VERSION = '2026-10';
  const PICKUP_LOCATION_ID = '116785643802';
  const PICKUP_ONLY_TAG = 'ship:pickup_only';

  let checkoutInProgress = false;

  async function getCart() {
    const response = await fetch('/cart.js', {
      headers: {
        Accept: 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('Could not read Shopify cart.');
    }

    return response.json();
  }

  async function cartContainsPickupOnlyProduct(cart) {
    /*
     * /cart.js does not reliably give us the product tags,
     * so we check each unique product through Shopify's
     * public product JSON endpoint.
     */
    const handles = [
      ...new Set(
        cart.items
          .map((item) => item.handle)
          .filter(Boolean)
      )
    ];

    const products = await Promise.all(
      handles.map(async (handle) => {
        const response = await fetch(`/products/${handle}.js`);

        if (!response.ok) {
          throw new Error(`Could not load product: ${handle}`);
        }

        return response.json();
      })
    );

    return products.some((product) => {
      const tags = Array.isArray(product.tags)
        ? product.tags
        : String(product.tags || '')
            .split(',')
            .map((tag) => tag.trim());

      return tags.includes(PICKUP_ONLY_TAG);
    });
  }

  async function createPickupCheckout(cart) {
    const query = `
      mutation CartCreate($input: CartInput!) {
        cartCreate(input: $input) {
          cart {
            id
            checkoutUrl
            buyerIdentity {
              preferences {
                delivery {
                  deliveryMethod
                  pickupHandle
                }
              }
            }
          }
          userErrors {
            field
            message
          }
          warnings {
            code
            message
          }
        }
      }
    `;

    const lines = cart.items.map((item) => ({
      merchandiseId: `gid://shopify/ProductVariant/${item.variant_id}`,
      quantity: item.quantity
    }));

    const variables = {
      input: {
        lines,
        buyerIdentity: {
          countryCode: 'IL',
          preferences: {
            delivery: {
              deliveryMethod: ['PICK_UP'],
              pickupHandle: [PICKUP_LOCATION_ID]
            }
          }
        }
      }
    };

    const response = await fetch(
      `https://${SHOP_DOMAIN}/api/${API_VERSION}/graphql.json`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN
        },
        body: JSON.stringify({
          query,
          variables
        })
      }
    );

    if (!response.ok) {
      throw new Error(`Storefront API error: ${response.status}`);
    }

    const result = await response.json();

    const payload = result?.data?.cartCreate;

    if (payload?.userErrors?.length) {
      console.error('Pickup checkout userErrors:', payload.userErrors);
      throw new Error(payload.userErrors[0].message);
    }

    if (!payload?.cart?.checkoutUrl) {
      console.error('Pickup checkout result:', result);
      throw new Error('Shopify did not return a checkout URL.');
    }

    return payload.cart.checkoutUrl;
  }

  async function handleCheckout(event) {
    const checkoutButton = event.target.closest(
      'button[name="checkout"], input[name="checkout"], [name="checkout"]'
    );

    if (!checkoutButton || checkoutInProgress) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    checkoutInProgress = true;

    const originalText =
      checkoutButton.tagName === 'INPUT'
        ? checkoutButton.value
        : checkoutButton.textContent;

    try {
      if (checkoutButton.tagName === 'INPUT') {
        checkoutButton.value = 'טוען...';
      } else {
        checkoutButton.textContent = 'טוען...';
      }

      checkoutButton.disabled = true;

      const cart = await getCart();

      const hasPickupOnly = await cartContainsPickupOnlyProduct(cart);

      /*
       * No pickup-only product:
       * use Shopify's normal checkout.
       */
      if (!hasPickupOnly) {
        window.location.href = '/checkout';
        return;
      }

      /*
       * Pickup-only product exists:
       * create a Storefront cart whose preferred delivery
       * method is pickup at the Habima location.
       */
      const checkoutUrl = await createPickupCheckout(cart);

      window.location.href = checkoutUrl;
    } catch (error) {
      console.error('FujiMake pickup checkout error:', error);

      /*
       * Fail safely:
       * if our custom logic ever breaks, don't trap the customer
       * in the cart. Send them to normal Shopify checkout.
       */
      window.location.href = '/checkout';
    } finally {
      checkoutInProgress = false;

      checkoutButton.disabled = false;

      if (checkoutButton.tagName === 'INPUT') {
        checkoutButton.value = originalText;
      } else {
        checkoutButton.textContent = originalText;
      }
    }
  }

  document.addEventListener('click', handleCheckout, true);
})();